<template>
  <div
    class="col-lg-12 ctr_trm"
    @copy.prevent
    @cut.prevent
    @selectstart.prevent
  >
    <p class="p1 subtitle">PT Digital Kripto Indonesia</p>
    <p class="p1">
      Pemberitahuan dan Pernyataan Risiko ini diberikan kepada anda oleh PT
      Digital Kripto Indonesia, sebuah perseroan terbatas Indonesia dengan
      kantor terdaftar di AXA Tower, Kuningan city, Axa Tower, Jl. Prof. DR.
      Satrio, RT.14/RW.4, Kuningan, Karet Kuningan, Kecamatan Setiabudi, Kota
      Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12940, yang didirikan
      berdasarkan hukum Negara Republik Indonesia (Pegasus Exchange) sebelum
      anda menggunakan Layanan Pegasus Exchange (selanjutnya disebut sebagai
      &quot;Pemberitahuan Risiko&quot;).
    </p>
    <h2 class="text_h">A. Penafsiran Pemberitahuan Risiko</h2>
    <p class="p1">
      Semua istilah yang digunakan dalam Pemberitahuan Risiko ini, yang
      didefinisikan dalam Perjanjian Konsumen Pegasus Exchange (&quot;Perjanjian
      Konsumen&quot;) dan Syarat dan Ketentuan Pegasus Exchange (&quot;Syarat
      dan Ketentuan&quot;), memiliki arti dan konstruksi yang sama sebagaimana
      diatur di sini.
    </p>
    <h2 class="text_h">B. Layanan Pegasus Exchange</h2>
    <p class="p1">
      Pemberitahuan ini memberikan anda informasi tentang risiko yang terkait
      dengan Layanan Pegasus Exchange. Sebelum menggunakan Layanan Pegasus
      Exchange, disarankan agar anda sebagai Konsumen telah membaca seluruh isi
      Pemberitahuan Risiko ini, serta dokumen lain yang disebutkan di dalamnya.
      Setiap Layanan Pegasus Exchange memiliki risiko tersendiri. Pemberitahuan
      Risiko ini memberikan gambaran umum tentang risiko saat anda menggunakan
      Layanan Pegasus Exchange.
    </p>
    <p class="p1">
      Anda menyadari bahwa pernyataan singkat ini tidak dapat merinci semua
      risiko atau aspek penting lainnya dari perdagangan Aset Digital dan/atau
      Aset Kripto, dan dengan demikian Pemberitahuan Risiko ini tidak
      menjelaskan semua risiko atau bagaimana risiko tersebut terkait dengan
      keadaan pribadi anda. Penting bagi anda untuk memahami risiko yang
      terlibat sepenuhnya sebelum memutuskan untuk menggunakan Layanan Pegasus
      Exchange. Oleh karena itu anda harus mempelajari aktivitas Perdagangan
      Aset Digital dan/atau Aset Kripto dengan cermat sebelum memutuskan untuk
      melakukan transaksi.
    </p>
    <p class="p1">
      Konsumen mengakui adanya kemungkinan risiko yang terkait dengan penggunaan
      Layanan Pegasus Exchange. Risiko kehilangan dalam perdagangan atau
      pemegangan Aset Digital dan/atau Aset Kripto mungkin besar. Maka Konsumen
      sebaiknya mempertimbangkan secara hati-hati apakah perdagangan atau
      pemegangan Aset Digital dan/atau Aset Kripto sesuai mengingat kondisi
      finansial pribadi anda.
    </p>
    <p class="p1">
      Konsumen mengakui bahwa risiko tambahan mungkin timbul dalam penggunaan
      Layanan Pegasus Exchange, seperti fluktuasi harga, kegagalan sistem dan
      risiko terkait lainnya. Pegasus Exchange tidak akan bertanggung jawab atas
      segala kehilangan yang timbul dari risiko di luar pengendalian Pegasus
      Exchange.
    </p>
    <p class="p1">
      Pengelolaan risiko-risiko yang tersebut di atas adalah tanggung jawabnya
      Konsumen. Oleh karena itu, Konsumen disarankan untuk berhati-hati dengan
      kondisi keuangannya dan memastikan bahwa Konsumen siap untuk menghadapi
      risiko sebelum mengambil keputusan. Semua keputusan mengenai perdagangan
      Aset Digital dan/atau Aset Kripto adalah keputusan yang sadar dan
      independen dari Konsumen dan tidak dilakukan atas paksaan apa pun.
    </p>
    <h2 class="text_h">C. Risiko Pasar</h2>
    <p class="p1">
      Perdagangan Aset Kripto adalah aktivitas yang berisiko dan tunduk pada
      risiko pasar dan volatilitas harga yang tinggi. Perubahan nilai dan harga
      mungkin signifikan dan dapat terjadi dengan cepat dan tanpa peringatan.
      Akibatnya, ada risiko kerugian terhadap membeli, menjual, menahan,
      menginvestasikan, dan memperdagangkan Aset Digital dan/atau Aset Kripto
      apa pun.
    </p>
    <p class="p1">
      Pelaksanaan yang terdahulu bukan merupakan indikator yang dapat diandalkan
      untuk pelaksanaan di kemudian hari. Nilai investasi dan pengembalian apa
      pun bisa turun dan juga naik, dan ada kemungkinan anda tidak mendapatkan
      kembali jumlah yang anda telah investasikan.
    </p>
    <p class="p1">
      Pegasus Exchange tidak akan bertanggung jawab atas setiap perubahan atau
      fluktuasi Aset Digital dan/atau Aset Kripto yang diperdagangkan.
    </p>
    <h2 class="text_h">D. Risiko Hukum</h2>
    <p class="p1">
      Perubahan hukum dan peraturan perundang-undangan dapat mempengaruhi nilai
      Aset Digital dan/atau Aset Kripto secara material. Risiko ini tidak dapat
      diprediksi dan dapat bervariasi dari pasar ke pasar.
    </p>
    <h2 class="text_h">E. Risiko Likuiditas</h2>
    <p class="p1">
      Aset Digital dan/atau Aset Kripto mungkin memiliki likuiditas terbatas
      yang dapat mempersulit atau tidak memungkinkan anda untuk menjual atau
      keluar dari suatu posisi saat anda ingin melakukannya. Hal ini dapat
      terjadi kapan saja, termasuk pada saat pergerakan harga yang cepat (rapid
      price movements).
    </p>
    <h2 class="text_h">F. Biaya dan Ongkos</h2>
    <p class="p1">
      Biaya dan ongkos kami ditetapkan di
      <a
        href="https://pegasusexchange.id/"
        target="_blank"
        rel="noopener noreferrer"
        >https://pegasusexchange.id/</a
      >. Pegasus Exchange dapat, atas kebijakannya sendiri, memperbarui biaya
      dan ongkos dari waktu ke waktu. Mohon perhatikan semua biaya dan biaya
      yang dikenakan kepada anda, karena biaya dan biaya tersebut akan
      mempengaruhi keuntungan yang anda hasilkan dari penggunaan Layanan Pegasus
      Exchange.
    </p>
    <h2 class="text_h">G. Risiko Ketersediaan</h2>
    <p class="p1">
      Kami tidak menjamin bahwa Layanan Pegasus Exchange akan tersedia pada
      waktu tertentu atau Layanan Pegasus Exchange tidak akan mengalami gangguan
      layanan atau kemacetan jaringan (network congestion) yang tidak
      direncanakan. Anda mungkin tidak dapat membeli, menjual, menyimpan,
      mengalih, mengirim, atau menerima Aset Digital dan/atau Aset Kripto ketika
      anda ingin melakukannya.
    </p>
    <h2 class="text_h">H. Risiko Pihak Ketiga</h2>
    <p class="p1">
      Pihak ketiga, seperti penyedia pembayaran, kustodian, dan mitra perbankan
      dapat terlibat dalam penyediaan Layanan Pegasus Exchange. Anda dapat
      tunduk pada Syarat dan Ketentuan pihak ketiga ini, dan Pegasus Exchange
      mungkin tidak bertanggung jawab atas kerugian apa pun yang dapat
      ditimbulkan oleh pihak ketiga tersebut kepada anda.
    </p>
    <h2 class="text_h">I. Risiko Keamanan</h2>
    <p class="p1">
      Tidak mungkin bagi Pegasus Exchange untuk menghilangkan semua risiko
      keamanan. Anda bertanggung jawab untuk menjaga keamanan kata sandi Akun
      Pegasus Exchange anda, dan anda dapat bertanggung jawab atas semua
      transaksi di bawah Akun Pegasus Exchange anda, baik yang anda
      mengizinkannya atau tidak. Transaksi dalam Aset Digital dan/atau Aset
      Kripto mungkin tidak dapat diubah, dan kerugian karena transaksi yang
      menipu atau tidak sah mungkin tidak dapat dipulihkan.
    </p>
    <h2 class="text_h">J. Risiko terkait dengan Aset Digital/Aset Kripto</h2>
    <p class="p1">
      Mengingat sifat Aset Digital dan/atau Aset Kripto dan teknologi yang
      mendasarinya, ada sejumlah risiko intrinsik, termasuk namun tidak terbatas
      pada:
    </p>
    <ul class="ul-sub">
      <li class="li-sub">
        <span class="li-label">1.</span> kesalahan, cacat, hack, eksploitasi,
        gangguan, kegagalan protokol atau keadaan tak terduga yang terjadi
        sehubungan dengan Aset Digital dan/atau Aset Kripto atau teknologi atau
        sistem ekonomi yang menjadi dasar Aset Digital dan/atau Aset Kripto;
      </li>
      <li class="li-sub">
        <span class="li-label">2.</span> transaksi dalam Aset Digital dan/atau
        Aset Kripto menjadi tidak dapat diubah. Sebagai akibat, kerugian karena
        penipuan atau transaksi yang tidak disengaja mungkin tidak dapat
        dipulihkan;
      </li>
      <li class="li-sub">
        <span class="li-label">3.</span> perkembangan teknologi yang mengarah
        pada Aset Digital dan/atau Aset Kripto yang tidak dapat dipakai lagi;
      </li>
      <li class="li-sub">
        <span class="li-label">4.</span> keterlambatan yang menyebabkan
        transaksi tidak diselesaikan pada tanggal pengiriman yang dijadwalkan;
        dan
      </li>
      <li class="li-sub">
        <span class="li-label">5.</span> serangan terhadap protokol atau
        teknologi di mana Aset Digital dan/atau Aset Kripto bergantung,
        termasuk, namun tidak terbatas pada:
        <ul class="ul-sub ul-nested">
          <li class="li-sub">penolakan layanan terdistribusi;</li>
          <li class="li-sub">serangan sybil;</li>
          <li class="li-sub">phishing;</li>
          <li class="li-sub">rekayasa sosial;</li>
          <li class="li-sub">hacking;</li>
          <li class="li-sub">smurfing;</li>
          <li class="li-sub">malware;</li>
          <li class="li-sub">pengeluaran ganda;</li>
          <li class="li-sub">
            penambangan mayoritas, berbasis konsensus atau serangan penambangan
            lainnya;
          </li>
          <li class="li-sub">kampanye informasi yang salah;</li>
          <li class="li-sub">fork; dan</li>
          <li class="li-sub">spoofing.</li>
        </ul>
      </li>
    </ul>
    <h2 class="text_h">K. Tidak Ada Nasihat Finansial</h2>
    <p class="p1">
      Kami tidak memberikan saran dan nasihat Finansial sehubungan dengan produk
      atau layanan kami. Kami terkadang memberikan informasi faktual, informasi
      tentang prosedur transaksi dan informasi tentang potensi risiko. Namun,
      setiap keputusan untuk menggunakan produk atau layanan kami dibuat oleh
      anda. Tidak ada komunikasi atau informasi yang diberikan kepada anda oleh
      Pegasus Exchange yang dimaksudkan sebagai, atau akan dianggap atau
      ditafsirkan sebagai, nasihat investasi, nasihat keuangan, nasihat
      perdagangan, atau nasihat lainnya. Anda bertanggung jawab penuh untuk
      menentukan apakah investasi, strategi investasi, atau transaksi terkait
      sesuai untuk anda sesuai dengan tujuan investasi pribadi, keadaan
      keuangan, dan toleransi risiko anda.
    </p>
    <h2 class="text_h">L. Tidak Ada Pemantauan</h2>
    <p class="p1">
      Pegasus Exchange bukan pialang (broker), perantara, agen, atau penasihat
      anda dan tidak memiliki hubungan kepercayaan atau kewajiban kepada anda
      sehubungan dengan perdagangan atau keputusan atau aktivitas lain yang anda
      lakukan menggunakan Layanan Pegasus Exchange. Kami tidak memantau apakah
      penggunaan anda atas Layanan Pegasus Exchange konsisten dengan tujuan dan
      sasaran keuangan anda. Anda bebas untuk menilai apakah sumber daya
      keuangan anda memadai untuk aktivitas keuangan anda bersama kami, dan
      untuk selera risiko anda dalam produk dan layanan yang anda gunakan.
    </p>
    <p class="p1">
      Pasar Aset Digital/Aset Kripto buka 24 jam sehari, 7 hari seminggu.
      Perubahan harga yang cepat dapat terjadi kapan saja, termasuk di luar jam
      kerja normal.
    </p>
    <h2 class="text_h">M. Pajak, Peraturan atau Nasihat Hukum</h2>
    <p class="p1">
      Perpajakan Aset Digital dan/atau Aset Kripto tidak pasti, dan anda
      bertanggung jawab untuk menentukan pajak apa yang mungkin menjadi tanggung
      jawab anda, dan bagaimana penerapannya, saat bertransaksi melalui Layanan
      Pegasus Exchange. Anda bertanggung jawab untuk melaporkan dan membayar
      pajak apa pun yang mungkin timbul dari bertransaksi dan perdagangan di
      Layanan Pegasus Exchange, dan anda mengakui bahwa Pegasus Exchange tidak
      memberikan nasihat hukum atau pajak terkait dengan transaksi dan
      perdagangan ini. Jika anda memiliki keraguan tentang status atau kewajiban
      pajak anda saat menggunakan Layanan Pegasus Exchange, atau sehubungan
      dengan Aset Digital dan/atau Aset Kripto yang disimpan dalam akun Pegasus
      Exchange anda, anda dapat mencari nasihat independen.
    </p>
    <p class="p1">
      Anda mengakui bahwa, ketika, dimana dan sebagaimana diwajibkan oleh hukum
      dan peraturan perundang-undangan yang berlaku, Pegasus Exchange akan
      melaporkan informasi mengenai transaksi, transfer, distribusi atau
      pembayaran anda kepada pajak atau otoritas publik lainnya. Demikian pula,
      ketika, di mana dan sebagaimana diwajibkan oleh hukum yang berlaku,
      Pegasus Exchange akan memotong pajak terkait dengan transaksi, transfer,
      distribusi, atau pembayaran anda. Hukum dan peraturan perundang-undangan
      yang berlaku juga dapat meminta Pegasus Exchange untuk meminta informasi
      pajak, status, sertifikat, atau dokumentasi tambahan kepada anda. Anda
      mengakui bahwa kegagalan untuk menjawab permintaan ini dalam jangka waktu
      yang ditentukan, dapat mengakibatkan pemotongan pajak oleh Pegasus
      Exchange, untuk dikirim ke otoritas pajak sebagaimana ditentukan oleh
      hukum yang relevan. Anda dianjurkan untuk mencari nasihat pajak
      profesional dan pribadi mengenai hal di atas dan sebelum melakukan
      transaksi Aset Digital apa pun.
    </p>
    <h2 class="text_h">N. Risiko Komunikasi</h2>
    <p class="p1">
      Ketika anda berkomunikasi dengan kami melalui komunikasi elektronik, anda
      harus menyadari bahwa komunikasi elektronik dapat gagal, dapat tertunda,
      mungkin tidak aman dan/atau tidak dapat mencapai tujuan yang diinginkan.
    </p>
    <h2 class="text_h">O. Mata Uang</h2>
    <p class="p1">
      Fluktuasi nilai tukar mata uang akan berdampak pada keuntungan dan
      kerugian anda.
    </p>
    <h2 class="text_h">P. Risiko Hukum</h2>
    <p class="p1">
      Perubahan hukum dan peraturan perundang-undangan dapat mempengaruhi nilai
      Aset Digital dan/atau Aset Kripto secara material. Risiko ini tidak dapat
      diprediksi dan dapat bervariasi dari pasar ke pasar.
    </p>
    <h2 class="text_h">Q. Pernyataan Konsumen</h2>
    <p class="p1">
      Anda juga harus membaca dan memahami informasi yang diberikan dari Pegasus
      Exchange, termasuk namun tidak terbatas pada Perjanjian Konsumen, Syarat
      dan Ketentuan dan Kebijakan Privasi Pegasus Exchange sebelum melakukan
      transaksi Aset Kripto dan/atau Aset Digital.
    </p>
    <p class="p1">
      Dengan mendaftar sebagai Konsumen, anda menyatakan bahwa anda telah
      membaca, mengerti, memahami, mengamati, menyetujui dan menerima
      Pemberitahuan Risiko ini.
    </p>
    <p class="p1">
      Dokumen Pemberitahuan Risiko ini dibuat dalam bahasa Indonesia dan bahasa
      Inggris.
    </p>
    <p class="p1">
      Anda dengan ini menyatakan bahwa anda telah menerima dan membaca
      Pemberitahuan dan Pernyataan Risiko, serta memahami dan menyetujui isinya.
    </p>
    <p class="p1 updated">
      <em>Terakhir Diperbarui pada tanggal 20/05/2026.</em>
    </p>
  </div>
</template>

<script>
// node_modules

// applibs

export default {
  components: {},
  data() {
    return {
      web_domain: "pegasusexchange.id",
    };
  },
};
</script>

<style scoped>
.text_h {
  margin-left: -20px;
  padding-top: 20px;
}
h2.head_txt {
  margin-top: 14pt;
  margin-bottom: 14pt;
  text-align: justify;
  font-size: 18pt;
}
.subtitle {
  font-weight: 600;
  margin-bottom: 1rem;
}
.updated {
  margin-top: 2rem;
  font-style: italic;
}
.p1 {
  margin-top: 14pt;
  margin-bottom: 14pt;
  text-align: justify;
  font-size: 16px;
}
.ul-letter,
.ul-sub {
  margin: 0 0 14pt 0;
  padding-left: 32pt;
  list-style: none;
}
.ul-nested {
  margin-top: 10pt;
  padding-left: 20pt;
}
.li-letter,
.li-sub {
  margin-top: 10pt;
  text-align: justify;
  font-size: 16px;
}
.li-label {
  font-weight: 600;
}
.text_h,
h1,
h2 {
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
}
.ctr_trm {
  max-width: 932px;
  padding: 0 20px;
  z-index: 995;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.head_txt {
  font-size: 28px;
  margin-left: -20px;
}
.ctr_trm a {
  color: #4da3ff;
  word-break: break-all;
}
@media (max-width: 500px) {
  .text_h,
  .head_txt,
  h1,
  h2 {
    font-size: 16px;
    margin-top: 20px;
  }
  .p1,
  .li-letter,
  .li-sub {
    font-size: 14px;
  }
}
</style>
